import { useCreation } from 'ahooks'
import { isNumber, isString } from 'lodash'

import { FormLayoutProps } from '../../FormLayout/interface'
import {
  SchemaFormLabelWidthCalcFn,
  SchemaFormLayoutProps,
  SchemaItem
} from '../interface'
import { hasTooltip } from '../utils/hasTooltip'
import { isExpression } from '../utils/isExpression'
import { isReqiredField } from '../utils/isRequired'
import { isVisibleField } from '../utils/isVisible'

const calcLabelWidth = (
  schema: SchemaItem[],
  calcFn: SchemaFormLabelWidthCalcFn
) => {
  let min = 0,
    max = 0,
    total = 0,
    length = 0

  const loop = (fields: SchemaItem[]) => {
    for (const field of fields) {
      if (
        (field.type === 'object' || field.type === 'void') &&
        field.properties
      ) {
        loop(Object.values(field.properties))
        continue
      }

      if (
        !isString(field.title) ||
        !isVisibleField(field) ||
        isExpression(field.title)
      ) {
        continue
      }

      let len = `${field.title}`.length

      if (isReqiredField(field)) {
        len += 1
      }

      if (hasTooltip(field)) {
        len += 2
      }

      if (len > max) {
        max = len
      }

      if (len < min || min === 0) {
        min = len
      }

      total += len
      length++
    }
  }

  loop(schema)

  return calcFn({ min, max, total, length })
}

/**
 * 根据表单项的中文标题计算最佳的 labelWidth
 */
export const useSmartLayout = ({
  schema,
  layout = {}
}: {
  schema: SchemaItem[]
  layout?: SchemaFormLayoutProps
}): FormLayoutProps => {
  return useCreation(() => {
    if (isString(layout.labelWidth) || isNumber(layout.labelWidth)) {
      return layout
    }

    const labelWidth = calcLabelWidth(
      schema,
      layout.labelWidth ?? (({ max }) => max)
    )

    const totalLabelWidth = layout.colon !== false ? labelWidth + 1 : labelWidth

    return {
      ...layout,
      labelAlign: layout.labelAlign ?? 'right',
      labelWidth: `${totalLabelWidth}em`
    }
  }, [schema, layout])
}
